var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "section",
    {
      staticClass: "cw-block-edit",
    },
    [
      _vm.preview
        ? _c("header", [_vm._v(_vm._s(_vm.$gettext("Bearbeiten")))])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "cw-block-features-content",
        },
        [
          _c(
            "div",
            {
              on: {
                click: function click($event) {
                  _vm.exitHandler = true
                },
              },
            },
            [_vm._t("edit")],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "cw-button-box",
            },
            [
              _c(
                "button",
                {
                  staticClass: "button accept",
                  on: {
                    click: function click($event) {
                      _vm.$emit("store")
                      _vm.exitHandler = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$gettext("Speichern")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "button cancel",
                  on: {
                    click: function click($event) {
                      _vm.$emit("close")
                      _vm.exitHandler = false
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$gettext("Abbrechen")))]
              ),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }